<template>
    <v-app>
        <head-layout />
        <v-container>
            <slot />
        </v-container>
    </v-app>
</template>

<script>
import HeadLayout from "@/Layouts/HeadLayout";
export default {
    components: {
        HeadLayout,
    },
};
</script>
